import LookupResourceChip from "./LookupResourceChip";

export default LookupResourceChip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/LookupResourceChip/index.tsx